import React from "react";

function Tv() {
  return (
    <div>
      <h1 className="center">tv Page</h1>
    </div>
  );
}

export default Tv;
